var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificaiton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 122,
    viewBox: "0 0 121 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.4252 40.6456C90.4252 32.6529 87.2501 24.9874 81.5983 19.3357C75.9466 13.6839 68.2811 10.5088 60.2884 10.5088C52.2956 10.5088 44.6301 13.6839 38.9784 19.3357C33.3266 24.9874 30.1515 32.6529 30.1515 40.6456C30.1515 75.8053 15.0831 85.8509 15.0831 85.8509H105.494C105.494 85.8509 90.4252 75.8053 90.4252 40.6456Z",
    stroke: "#CD7F32",
    strokeWidth: 4.52053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9778 105.942C68.0947 107.465 66.8272 108.728 65.3022 109.607C63.7772 110.485 62.0482 110.947 60.2883 110.947C58.5284 110.947 56.7994 110.485 55.2744 109.607C53.7494 108.728 52.4819 107.465 51.5989 105.942",
    stroke: "#CD7F32",
    strokeWidth: 4.52053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificaiton);
export default __webpack_public_path__ + "static/media/notificaiton.5e65399940bb6cae6df02fadc4d42bda.svg";
export { ForwardRef as ReactComponent };